/**
 * example) 9,999,999,999
 */
export function priceFilter(number: any): string {
    if (number && typeof number === 'number') {
        return number.toLocaleString();
    }
    return number;
}

const isNationalNumber = (str: string) => /^(082|82)/.test(str);
const isCompanyOfficialNumber = (str: string) => /^(1\d{3})/.test(str);
const formatPhoneNumberByType = (str: string) => {
    if (isNationalNumber(str)) {
        return formatNationalNumber(str);
    }
    return formatLocalNumber(str);
};

/**
 * @description 전화번호 formatter 인풋용
 * @param number
 * @returns
 */
export function formatPhoneNumberForInput(phoneNumber: string) {
    if (phoneNumber == null || phoneNumber == undefined) return '';
    const string = phoneNumber.replace(/[^0-9]/g, '');
    return formatPhoneNumberByType(string);
}

/**
 * @description 전화번호 formatter, 디스플레이용 (마스킹되어도 포멧팅 처리)
 * @param number
 * @returns
 */
export function formatPhoneNumber(phoneNumber: string) {
    if (phoneNumber == null || phoneNumber == undefined) return '';
    const string = phoneNumber.replace(/[^0-9*]/g, '');
    return formatPhoneNumberByType(string);
}

/**
 * 국가번호 없는 전화번호 포맷팅
 * @param str
 * @returns
 */
function formatLocalNumber(phoneNumber: string) {
    if (isCompanyOfficialNumber(phoneNumber) && phoneNumber.length > 4) {
        return phoneNumber.replace(/^(1[0-9*]{3})([0-9*]+)?$/, '$1-$2'); // 1588
    } else if (phoneNumber.length < 5) {
        return phoneNumber;
    } else if (phoneNumber.length < 7) {
        return phoneNumber.replace(/^(02|0[0-9*]{2})([0-9*]+)?$/, '$1-$2'); // 02|010
    } else if (phoneNumber.length < 9) {
        return phoneNumber.replace(
            /^(02|0504|0505|0[0-9*]{2})([0-9*]+)?$/,
            '$1-$2',
        ); // 02|0504|0505|010
    }
    return phoneNumber.replace(
        /^(02|0504|0505|0[0-9*]{2})([0-9*]{1,4})([0-9*]{4,})$/,
        '$1-$2-$3',
    );
}

/**
 * 국가번호 있는 전화번호 포맷팅
 * @param str
 * @returns
 */
function formatNationalNumber(str: string) {
    const phoneNumber = str.replace(/^[0]/g, '');
    if (phoneNumber.length < 3) {
        return `+${phoneNumber}`;
    } else if (phoneNumber.length < 7) {
        return phoneNumber.replace(/^(82)([0-9*]+)?$/, '+$1-$2');
    } else if (phoneNumber.length < 9) {
        return phoneNumber.replace(
            /^(82)(2|[0-9*]{2})([0-9*]+)?$/,
            '+$1-$2-$3',
        );
    }
    return phoneNumber.replace(
        /^(82)(2|[0-9*]{2})([0-9*]{1,4})([0-9*]{4,})$/,
        '+$1-$2-$3-$4',
    );
}

export function formatCorporateRegistrationNumber(phoneNumber = '') {
    if (typeof phoneNumber !== 'string') return '';
    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

    // ( 3 - 2 - 5)
    if (phoneNumber.length < 4) {
        return phoneNumber;
    } else if (phoneNumber.length < 6) {
        return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3)}`;
    } else {
        return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
            3,
            5,
        )}-${phoneNumber.substring(5)}`;
    }
}
